import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

const app = firebase.initializeApp({
  apiKey: 'AIzaSyCdGvjwfpPwOnPMKofp2to9L3nfP9mLfC4',
  authDomain: 'bens-apps.firebaseapp.com',
  databaseURL: 'https://bens-apps.firebaseio.com',
  projectId: "bens-apps",
  storageBucket: "bens-apps.appspot.com",
  messagingSenderId: "618293202107",
  appId: "1:618293202107:web:304e9c22a39e02649b2d9e"
});

export const auth = app.auth();
export const db = app.firestore();

export const googleProvider = new firebase.auth.GoogleAuthProvider();

// offline support
/* eslint-disable */
db.enablePersistence().catch(console.error);
